import { NativeModules, Platform } from "react-native";

const LB = Platform.OS === "android" ? NativeModules.LockboxEnforcement : null;

export function lockboxEnforcementSupported() {
  return !!LB;
}

/**
 * @param {import('../lockbox/domain/types.js').EnforcementPlan} plan
 */
export async function submitRestrictionIntentNative(plan) {
  if (!LB?.submitRestrictionIntent) {
    return { ok: false, skipped: "lockbox_native_unavailable" };
  }
  const json = JSON.stringify(plan);
  return LB.submitRestrictionIntent(json);
}

/**
 * @returns {Promise<Array<{ packageName: string, label: string }>>}
 */
export async function getInstalledAppsNative() {
  if (!LB?.getInstalledApps) return [];
  const rows = await LB.getInstalledApps();
  if (!Array.isArray(rows)) return [];
  return rows
    .map((r) => ({
      packageName: String(r?.packageName || "").trim(),
      label: String(r?.label || r?.packageName || "").trim(),
    }))
    .filter((r) => r.packageName);
}

/**
 * @param {'monitor'|'soft'|'strict'} mode
 */
export async function setEnforcementModeNative(mode) {
  if (!LB?.setEnforcementMode) return;
  await LB.setEnforcementMode(mode);
}

/**
 * @returns {Promise<{ usageStatsGranted: boolean, overlayGranted: boolean, serviceRunning: boolean }>}
 */
export async function getEnforcementHealthNative() {
  if (!LB?.getEnforcementHealth) {
    return { usageStatsGranted: false, overlayGranted: true, serviceRunning: false };
  }
  return LB.getEnforcementHealth();
}

export async function startLockboxEnforcementNative() {
  if (!LB?.startEnforcement) return false;
  return LB.startEnforcement();
}

export async function stopLockboxEnforcementNative() {
  if (!LB?.stopEnforcement) return false;
  return LB.stopEnforcement();
}

export function openUsageAccessSettingsNative() {
  LB?.openUsageAccessSettings?.();
}

export function requestOverlayPermissionNative() {
  LB?.requestOverlayPermission?.();
}
